import { useContext } from 'react';
import { type OneDriveFile, type OneDriveFolder } from '../../types';
import ExternalFilesContext from '../../../../../../ExternalFilesContext';

const useIsAlreadyAttached = (
  oneDriveItem: OneDriveFile | OneDriveFolder,
): boolean => {
  const { externalFilesExternalIds } = useContext(ExternalFilesContext);

  return externalFilesExternalIds.includes(oneDriveItem.id);
};

export default useIsAlreadyAttached;
